import { ICON_COLOR, White } from '@zep-us/zus/tokens';
import { BookCoverIcon, XIcon } from '@/icons';
import { type AchievementStandard } from '@/shared/features/ai-quiz-generation/types';
import { Chip, Tooltip } from '@/ui_v3';
export const CodeChip = ({
  achievementStandard,
  onRemove
}: {
  achievementStandard: AchievementStandard;
  onRemove: () => void;
}) => {
  return <Tooltip.Provider data-sentry-element="unknown" data-sentry-component="CodeChip" data-sentry-source-file="CodeChip.tsx">
      <Tooltip.Root data-sentry-element="unknown" data-sentry-source-file="CodeChip.tsx">
        <Tooltip.Trigger asChild data-sentry-element="unknown" data-sentry-source-file="CodeChip.tsx">
          <Chip size="sm" className="h-lg cursor-pointer rounded-sm border border-violet-200 bg-violet-50 text-strong hover:bg-violet-100" data-sentry-element="Chip" data-sentry-source-file="CodeChip.tsx">
            <BookCoverIcon width={12} height={12} fill={ICON_COLOR.strong} data-sentry-element="BookCoverIcon" data-sentry-source-file="CodeChip.tsx" />
            <span className="line-clamp-1">{achievementStandard.code}</span>
            <XIcon size="2xs" fill={ICON_COLOR.strong} onClick={onRemove} data-sentry-element="XIcon" data-sentry-source-file="CodeChip.tsx" />
          </Chip>
        </Tooltip.Trigger>
        <Tooltip.Content side="bottom" className="max-w-[300px] bg-default text-body-sm-semibold text-default" data-sentry-element="unknown" data-sentry-source-file="CodeChip.tsx">
          <Tooltip.Arrow style={{
          fill: White
        }} data-sentry-element="unknown" data-sentry-source-file="CodeChip.tsx" />
          <span>{`[${achievementStandard.code}] ${achievementStandard.standard}`}</span>
        </Tooltip.Content>
      </Tooltip.Root>
    </Tooltip.Provider>;
};